import { fetchPost, fetchPut, fetchGet, rootApi } from '../helpers/api';

const userApi = `${rootApi}/users`;

export const create = userData => fetchPost(userApi, userData);

export const update = userData => fetchPut(userApi, userData);

export const deactivate = userId => fetchGet(`${userApi}/${userId}/deactivate`);

export const activate = userId => fetchGet(`${userApi}/${userId}/activate`);

export const search = criteria => fetchPost(`${userApi}/search`, criteria);

export const clientSearch = criteria => fetchPost(`${userApi}/searchCertainUser`, criteria);

export const subClientSearch = companyname => fetchGet(`${userApi}/queryUserByCompany/${companyname}`);